import GeneralHelper from "./generalHelper"
import { General } from "./metafiles"
import EventSubscriber from "./eventSubscriber"
import View from "./View"
import Pattern from "./pattern"

class addItemToCart {
  delay = 5000;
  isAdding = false;

  static adding(statusText) {

      statusText = statusText || "Adding to Cart";
      $("#wiz-add-cart .shopAdd").removeClass("added-to-cart").addClass("disabled adding-to-cart");
      $(".wizard-sections-container .wizard-section.open").addClass("wizard-loading element-loading");
      $(".addCartStatus img").attr("src", "https://assets.stahls.com/stahls/content/images/ajaxLoading.gif");
      $(".addCartStatus .status").text(statusText);
      $(".addCartStatus").stop().show();
      addItemToCart.isAdding = true;

      if ($("#wizard").data("wizard") && typeof($("#wizard").data("wizard").AdjustPreviewPosition) != "undefined") {
          $("#wizard").data("wizard").AdjustPreviewPosition();
      }
  }

  static added(statusText) {
      var shopMobile = typeof(isMobile) == "function" ? isMobile() : false;
      var addedCallBack = function() {
          $("#wiz-add-cart .shopAdd").removeClass("disabled adding-to-cart").addClass("added-to-cart");
          $(".wizard-sections-container .wizard-section.open").removeClass("wizard-loading element-loading");
          $(window).trigger("scroll");
          if (shopMobile) {
              $(".mobile-add-cart-continue").velocity("fadeIn", {
                  display: "block",
                  duration: 600
              });
          }
          // $(".wiz-go-to-cart").velocity("fadeIn", {
          //     display: "block",
          //     duration: 600
          // });
          // I guess this should be fired SID side with the ADD_TO_CART message
          addItemToCart.isAdding = false;
          View.wizardLoading(true, false, false);
      };
      statusText = statusText || "Added!";
      $(".addCartStatus img").attr("src", "https://assets.stahls.com/stahls/content/images/checkmark-icon.png");
      $(".addCartStatus .status").text(statusText);
      if ($(".addCartStatus").length) {
          $(".addCartStatus").show("slow", addedCallBack);
      } else {
          addedCallBack();
      }
  }

  static reset() {
    $('#add-to-cart').removeClass("added-to-cart");
  }

  static removed(statusText) {
      $(".addCartStatus").hide();
      $("#wiz-add-cart .shopAdd").removeClass("disabled adding-to-cart added-to-cart");
      $(".wizard-sections-container .wizard-section.open").removeClass("wizard-loading element-loading");
      addItemToCart.isAdding = false;
  }
}

function addedToCart(origCart, items) {
  if ( parent && parent.postMessage )
  {
    parent.postMessage(JSON.stringify({ sender : 'add-to-cart', content: [origCart, items] , type: "ITEM_ADDED_TO_CART" }), "*");
  }      
  window.AppInstance.instance().GROUPID = undefined; // Updated cart at least once, so new requests will be adding to cart instead
  if (addItemToCart) {
    addItemToCart.added();
  }
}

export default class PatternBuilderCart  {
  
  static jobData = {};
  static addItems = []
  static allItems = []
  static $container;
  static $qty;
  static productAvailability;
  static allMaterials = {};
  static qtyHtmlTemplate = '<h2>Material Selection</h2><div class="materialOptions wizard-selection plugin land-tiles"><div class="clearfix promo-masonry">{{#each Materials}}<div class="promos wizard-option wizard-shadow {{#if selected}}active{{/if}}" data-value="{{code}}"><div class="wiz-opt-container"><div class="top"><div class="main-section holds-check">{{{name}}}<i class="icon-checkmark-heavy"></i></div></div></div></div>{{/each}}</div></div><h2><strong>Select Quantity</strong></h2>{{#each Items}}<div class="product" data-sku="{{sku}}" data-material="{{material}}"><h2>{{#if title}}{{{title}}}{{else}}{{{description}}}{{/if}}</h2>{{#if note}}<div class="wizard-note">{{{note}}}</div>{{/if}}<input type="hidden" name="itemclass" value="{{itemClass}}" /><input type="hidden" name="sku" value="{{sku}}" /><div class="wiz-table"><div class="wiz-row">{{#each unitsOfMeasure}}<div class="wiz-col">{{{description}}}</div>{{/each}}<div class="wiz-col"></div></div><div class="wiz-row">{{#each unitsOfMeasure}}<div class="wiz-col uofm-cost" data-uofm="{{code}}"></div>{{/each}}<div class="wiz-col TotalMaterialLabelContainer">Total Yardage</div></div><div class="wiz-row">{{#each unitsOfMeasure}}<div class="wiz-col"><input type="number" name="qty" class="uofm numbers-only" {{#if qty}}value="{{qty}}"{{/if}}" min="0" data-uofm="{{code}}" /></div>{{/each}}<div class="wiz-col"><input type="number" name="qty" class="total-yardage numbers-only {{#if isPack}}round-up{{/if}}" min="0"/></div></div></div></div>{{/each}}';
  static extraCopy = {};
  static DEFAULT_ITEM = "stahls";
  static DEFAULT_MATERIAL = "EXP";
  static editParams = {};

  static Init(elSelector) {

    PatternBuilderCart.$container = $(elSelector);
    PatternBuilderCart.$qty = PatternBuilderCart.$container.find(".item-qty");

    if ( window.AppInstance.is_art_uploader() )
    {
      $("#order-info, .order-info").remove();
      $(".tab-content.choose-color .steps-nav .next-step").remove();
      $(".tab-content.choose-color .steps-nav").append('<a class="orangeButton finish-selection next-step">Finish</a>');

      $(".choose-color .finish-selection").click(function() {
        View.wizardLoading(true, false, true);
          Pattern.get_custom_pattern_job_data_with_links$().then(function (production_object) {
            
              let o = {
                FIELDNAME : window.AppInstance.instance().FIELDNAME,
                STEPINDEX: window.AppInstance.instance().STEPINDEX,
                jobData: production_object
              }

              //existing then updated
              if ( window.AppInstance.pattern_to_load() )
              {
                return Cx.Core.Config.update$({ Id: window.AppInstance.instance().EDITPATTERNID, Data: JSON.stringify(o), Archived: false, Tags: [{ Name: 'patternbuilder/EDITPARAMS' }] }).then(function(u){
                  o.EDITPATTERNID = window.AppInstance.instance().EDITPATTERNID ;
                  View.wizardLoading(false, false, false);
                  parent.postMessage(JSON.stringify({ sender : "finish-selection", type: "ARTWORKUPLOADER_CALLBACK", content: o }), "*");
                });
              } 
              else {
                return Cx.Core.Config.create$({ Data: JSON.stringify(o), Tags: [{ Name: 'patternbuilder/EDITPARAMS' }] }).then(function(r) {
                  o.EDITPATTERNID = r.Id ;
                  View.wizardLoading(false, false, false);
                  parent.postMessage(JSON.stringify({ sender : "finish-selection", type: "ARTWORKUPLOADER_CALLBACK", content: o }), "*");
                });
              }

          });
      });

      // var onElementHeightChange = function (elm, callback){
      //   var lastHeight = elm.clientHeight, newHeight;
      //   (function run(){
      //     newHeight = elm.clientHeight;
      //     if (lastHeight != newHeight || newHeight > window.innerHeight || $("#colorbox").is(":visible") && $("#colorbox").height() > window.innerHeight) callback();
      //     lastHeight = newHeight;

      //     if (elm.onElementHeightChangeTimer) clearTimeout(elm.onElementHeightChangeTimer);

      //     elm.onElementHeightChangeTimer = setTimeout(run, 200);
      //   })();
      // };


    //   onElementHeightChange(document.body, function() {
    //     parent.WizardExtensions.Functions.PatternBuilderResize(Math.max(document.body.clientHeight, $("#colorbox").is(":visible") ? $("#colorbox").height() : 0));
    //   });
   }

   PatternBuilderCart.getProducts();

  }


  static StahlsAPI() {
    return {
      "products": {
        "type": "GET",
        "endpoint": window.PatternBuilder.config().STAHLS_API_BASE + "products",
        "postdata": {
          "country": window.PatternBuilder.config().SHOPPER_COUNTRY,
          "group": window.PatternBuilder.config().WIZARD_ID,
          "shopperId": window.AppInstance.instance().SHOPPERID
        }
      },
      "pricing": {
        "type": "POST",
        "endpoint": window.PatternBuilder.config().STAHLS_API_BASE + (window.AppInstance.instance().SHOPPERID ? "shoppers/" + window.AppInstance.instance().SHOPPERID+ "/" : "") + "prices?country=" + window.PatternBuilder.config().SHOPPER_COUNTRY
      },
      "getcart": {
        "type": "GET",
        "endpoint": window.PatternBuilder.config().STAHLS_API_BASE + (window.AppInstance.instance().SHOPPERID ? "shoppers/" +window.AppInstance.instance().SHOPPERID + "/" : "") + "cart/groups"
      }
    };
  }

  static formatPrice(price) {
    return '$' + price.toFixed(2);
  }

  static getPricing(items, callback) {
    $.ajax({
      type: PatternBuilderCart.StahlsAPI().pricing.type,
      url: PatternBuilderCart.StahlsAPI().pricing.endpoint,
      crossDomain: true,
      data: JSON.stringify(items),
      contentType: "application/json"
    }).then(function(data) {
      if (typeof(callback) === "function") {
        callback(data);
      }
    }).fail(function(e) {
      GeneralHelper.errorOut(e);
    });
  }

  static resetCartButton() {
    addItemToCart.reset();
    PatternBuilderCart.$container.find(".shopAdd").removeClass("added-to-cart");
  }

  static getTotalPricing() {
    PatternBuilderCart.addItems = [];

    PatternBuilderCart.$qty.find(".product").each(function() {
      var _this = this;
      var sku = $.trim($(_this).find("input[name=sku]").val());
      var itemclass = $.trim($(_this).find("input[name=itemclass]").val());

      $(_this).find("input.uofm").each(function() {
        var uofm = $.trim($(this).data("uofm"));
        var qty = $(this).val();

        if (sku && uofm && qty > 0) {
          PatternBuilderCart.addItems.push({
            "itemclass": itemclass,
            "sku": sku,
            "quantity": qty,
            "unitOfMeasure": uofm
          });
        }
      });
    });

    PatternBuilderCart.$container.find(".shopAdd").removeClass("added-to-cart");
    if (!window.AppInstance.instance().GROUPID) { // No group ID, so not editing
      PatternBuilderCart.$container.find(".shopAdd").removeClass("update-group");
      PatternBuilderCart.editParams = {};
    }

    if (PatternBuilderCart.addItems.length > 0) {
      PatternBuilderCart.$container.find(".addCartBtn.loading-add").show();
      PatternBuilderCart.$container.find(".addCartBtn.disabled-add, .addCartBtn.enabled-add").hide();

      PatternBuilderCart.getPricing(PatternBuilderCart.addItems, function(data) {
        var totalPrice = 0;

        for (var i = 0, len = data.length; i < len; i++) {
          totalPrice += data[i].quantity * data[i].price;
        }

        PatternBuilderCart.$container.find(".total-price").text(PatternBuilderCart.formatPrice(totalPrice));
        PatternBuilderCart.$container.find(".addCartBtn.disabled-add, .addCartBtn.loading-add").hide();
        PatternBuilderCart.$container.find(".addCartBtn.enabled-add").show();
      });
    } else {
      PatternBuilderCart.$container.find(".total-price").text(PatternBuilderCart.formatPrice(0));
      PatternBuilderCart.$container.find(".addCartBtn.disabled-add").show();
      PatternBuilderCart.$container.find(".addCartBtn.enabled-add, .addCartBtn.loading-add").hide();
    }
  }

  static updatePricing() {
    PatternBuilderCart.getPricing(PatternBuilderCart.allItems, function(data) {
      for (var i = 0, len = data.length; i < len; i++) {
        PatternBuilderCart.$qty.find('.product[data-sku="' + data[i].sku + '"]').find('.uofm-cost[data-uofm="' + data[i].unitOfMeasure + '"]').text(PatternBuilderCart.formatPrice(data[i].price));
      }
    });
  }

  static extractItemInfo(itemClassCode, currQty, item) {
    var uofms = item.unitsOfMeasure && item.unitsOfMeasure.length > 0 ? item.unitsOfMeasure.sort(function(a,b){if(a.code < b.code) { return -1; } if(a.code > b.code) { return 1; } return 0;}) : [];
    var extractedInfo = {
      sku: item.sku,
      description: item.description,
      title: PatternBuilderCart.extraCopy && PatternBuilderCart.extraCopy[item.sku] ? PatternBuilderCart.extraCopy[item.sku].title : undefined,
      note: PatternBuilderCart.extraCopy && PatternBuilderCart.extraCopy[item.sku] ? PatternBuilderCart.extraCopy[item.sku].note : undefined,
      material: item.details ? item.details.materialCode : "",
      isPack: false,
      itemClass: itemClassCode,
      unitsOfMeasure: []
    };

    for (var i = 0, len = uofms.length; i < len; i++) {
      var myItemQty = currQty && currQty[item.sku] ? currQty[item.sku][uofms[i].code] : undefined;

      if (myItemQty && myItemQty > 0) {
        for (var key in PatternBuilderCart.allMaterials) {
          PatternBuilderCart.allMaterials[key].selected = false;
        }

        if (typeof(PatternBuilderCart.allMaterials[extractedInfo.material]) !== "undefined") {
          PatternBuilderCart.allMaterials[extractedInfo.material].selected = true;
        } else { // Mask
          for (var key in PatternBuilderCart.allMaterials) {
            if (PatternBuilderCart.allMaterials[key].mask && item.sku &&
              PatternBuilderCart.allMaterials[key].mask.toUpperCase() == item.sku.toUpperCase()) {
                PatternBuilderCart.allMaterials[key].selected = true;
            }
          }
        }
      }

      if (uofms[i].code && uofms[i].code.match(/pack$/i)) {
        extractedInfo.isPack = true;
      }

      extractedInfo.unitsOfMeasure.push({
        code: uofms[i].code,
        description: uofms[i].description,
        qty: myItemQty
      });
    }

    return extractedInfo;
  }

  static filterItemsBasedOnMaterial() {
    var selectedMaterial = PatternBuilderCart.$qty.find(".materialOptions .wizard-option.active").data("value");

    if (!selectedMaterial) {
      selectedMaterial = PatternBuilderCart.DEFAULT_MATERIAL;
      PatternBuilderCart.$qty.find(".materialOptions .wizard-option[data-value='" + selectedMaterial + "']").addClass("active");
    }

    selectedMaterial = $.trim(selectedMaterial);

    PatternBuilderCart.$qty.find(".product").each(function() {
      if (PatternBuilderCart.allMaterials[selectedMaterial]) {
        if ($.trim($(this).data("material")) == selectedMaterial || $.trim($(this).data("sku")) == $.trim(PatternBuilderCart.allMaterials[selectedMaterial].mask)) {
          $(this).show();
        } else {
          $("input.uofm, input.total-yardage", this).val("");
          $(this).hide();
        }
      }
    });

    $('.TotalMaterialLabelContainer').each( function() {
      this.innerHTML= ( selectedMaterial == "SBT") ? 'Total Sheets' : 'Total Yardage';
    });

    View.resize();
  }

  static refreshQtyStep(retainQty) {
    if (PatternBuilderCart.$qty && PatternBuilderCart.productAvailability) {
      var currQty = PatternBuilderCart.editParams.items, designerItems = [], defaultItems = [], selectedCategory = "", hasDesigerItems = false,
        tagsParts = window.AppInstance.instance().selected.Tags && window.AppInstance.instance().selected.Tags.length > 0 ? window.AppInstance.instance().selected.Tags[0].Name.split(/[/]+/) : "";

      if (tagsParts && tagsParts.length > 0 && tagsParts[General.category_root_level]) {
        selectedCategory = tagsParts[General.category_root_level];
      }

      if (retainQty) {
        currQty = {};
        PatternBuilderCart.$qty.find(".product").each(function() {
          var qtySku = $(this).data("sku");
          currQty[qtySku] = {};
          $(this).find("input.uofm").each(function() {
            if ($(this).val()) {
              currQty[qtySku][$(this).data("uofm")] = $(this).val();
            }
          });
        });
      }

      for (var j = 0, len = PatternBuilderCart.productAvailability.classes.length; j < len; j++) {

        if ( PatternBuilderCart.productAvailability.classes[j] !== undefined )
        {
          var products = PatternBuilderCart.productAvailability.classes[j].products;
          var itemClassCode = PatternBuilderCart.productAvailability.classes[j].code;

          for (var i = 0, len2 = products.length; i < len2; i++) {
            if (products[i].details) {
              var selCat = selectedCategory ? $.trim(selectedCategory.toLowerCase()) : undefined;
              var desName = products[i].details.designerName ? $.trim(products[i].details.designerName.toLowerCase()) : undefined;
              var matCode = products[i].details.materialCode;

              if (products[i].details.title || products[i].details.note) {
                PatternBuilderCart.extraCopy[products[i].sku] = {
                  note: products[i].details.note,
                  title: products[i].details.title
                };
              }

              if (matCode) {
                if (typeof(PatternBuilderCart.allMaterials[matCode]) === "undefined") {
                  PatternBuilderCart.allMaterials[matCode] = {
                    code: matCode,
                    name: products[i].details.materialName,
                    mask: products[i].details.maskItemNumber,
                    selected: false
                  };
                }
              }

              if ((selCat && desName && selCat == desName) || products[i].details.isMask) {
                if (!products[i].details.isMask) { // Not a mask, at least 1 designer SKU
                  hasDesigerItems = true;
                }
                designerItems.push(PatternBuilderCart.extractItemInfo(itemClassCode, currQty, products[i]));
              }

              if (desName == PatternBuilderCart.DEFAULT_ITEM || products[i].details.isMask) {
                defaultItems.push(PatternBuilderCart.extractItemInfo(itemClassCode, currQty, products[i]));
              }
            }
          }
        }
      }

      PatternBuilderCart.$qty.html(Handlebars.compile(PatternBuilderCart.qtyHtmlTemplate)({ "Materials": PatternBuilderCart.allMaterials, "Items": hasDesigerItems ? designerItems : defaultItems }));

      // Bind Material selection events
      PatternBuilderCart.$qty.find(".materialOptions .wizard-option").click(function() {
        PatternBuilderCart.$qty.find(".materialOptions .wizard-option").removeClass("active");
        $(this).addClass("active");
        PatternBuilderCart.filterItemsBasedOnMaterial();
        PatternBuilderCart.getTotalPricing();
      });

      PatternBuilderCart.filterItemsBasedOnMaterial();
      PatternBuilderCart.getTotalPricing();

      PatternBuilderCart.$qty.find(".wiz-row").each(function() {
        PatternBuilderCart.updateTotalFromQuantities($(this));
      });

      PatternBuilderCart.allItems = [];
      for (var i = 0, len1 = PatternBuilderCart.productAvailability.classes.length; i < len1; i++) {
        var products = PatternBuilderCart.productAvailability.classes[i].products;
        if (products) {
          for (var j = 0, len2 = products.length; j < len2; j++) {
            var sku = products[j].sku;
            var uofms = products[j].unitsOfMeasure;
            if (uofms) {
              for (var k = 0, len3 = uofms.length; k < len3; k++) {
                PatternBuilderCart.allItems.push({
                  "sku": sku,
                  "quantity": 1,
                  "unitOfMeasure": uofms[k].code
                });
              }
            }
          }

          PatternBuilderCart.updatePricing();
        }
      }
    }
    //EventSubscriber.Subscribe();
    EventSubscriber.SubscribeCart();
  }

  static getProducts() {
    $.ajax({
      type: PatternBuilderCart.StahlsAPI().products.type,
      url: PatternBuilderCart.StahlsAPI().products.endpoint,
      crossDomain: true,
      data: PatternBuilderCart.StahlsAPI().products.postdata,
      contentType: "application/json"
    }).then(function(data) {
      PatternBuilderCart.productAvailability = data;
      PatternBuilderCart.refreshQtyStep();
    }).fail(function(e) {
      GeneralHelper.errorOut(e);
    });
  }

  static postCartGroupCall(postData, groupId, origCart, items) {
    var _addedToCart = addedToCart ;
    $.ajax({
      type: groupId ? "PUT": "POST",
      url: window.PatternBuilder.config().STAHLS_API_BASE + (window.AppInstance.instance().SHOPPERID ? "shoppers/" + window.AppInstance.instance().SHOPPERID + "/" : "") + "cart/groups" + (groupId ? "/" + groupId : ""),
      crossDomain: true,
      data: postData,
      contentType: "application/json",
      success: function() {
        PatternBuilderCart.singleItemsAddCartCall(origCart, items); // Add next item recursively
      }
      ,error: function(e){
        GeneralHelper.errorOut(e);
        if ( addItemToCart !== undefined ) {
          addItemToCart.removed();
        }
        View.wizardLoading(true, false, false);
      }
    });
  }

  static singleItemsAddCartCall(origCart, items) {
    if (items && items.length > 0) { // Still have items left to add
        var item = items.shift();
        var groupId = undefined;
        var origQty = 0;

        if (origCart) {
            for (var i = 0, len1 = origCart.length; i < len1; i++) {
                var group = origCart[i];
                for (var j = 0, len2 = group.items.length; j < len2; j++) {
                    if ($.trim(group.items[j].sku) == item.sku && $.trim(group.items[j].unitOfMeasure) == item.unitOfMeasure) {
                        groupId = group.groupId;
                        origQty = parseInt(group.items[j].quantity);
                    }
                }
            }
        }

        if (groupId && origQty) {
            item.quantity = parseInt(item.quantity) + origQty;
        }

        // Add the single item to the cart
        PatternBuilderCart.postCartGroupCall(JSON.stringify({
            "groupId": groupId,
            "jobData": {},
            "items": [item]
        }), groupId, origCart, items);
    } else { // All items have been added
        // if (typeof (updateMiniCartInfo) != "undefined") {
        //     updateMiniCartInfo(true);
        // }
        addedToCart(origCart, items)

        //show export async call test button if applies
        if(AppInstance.instance().SHOW_DOWNLOAD)
        {
          console.log(PatternBuilderCart.jobData);
          View.toggle_export_async(true);
        }
          
        //window.AppInstance.instance().GROUPID = undefined; // Updated cart at least once, so new requests will be adding to cart instead
    }
}

  static setJobData(data) {
    PatternBuilderCart.jobData = data;
  }

  static addToCart(generalErrorMessage) {
    if (PatternBuilderCart.addItems.length > 0) {
      if (!window.AppInstance.instance().SHOPPERID) { // User is not logged in
        $("#dologin input[name=dologinAsync]").val("1");
        // GeneralHelper.open_general_box("#login-modal", undefined, { onClosed: function() {
          if (typeof(addItemToCart) !== "undefined") {
            addItemToCart.removed();
          }
          View.wizardLoading(true, false, false);
        // }});
      } else {
        PatternBuilderCart.doAddToCart(generalErrorMessage);
      }
    } else { // No items to add to cart
      GeneralHelper.open_general_box({
        "buttons": '<a class="orangeButton" onclick="$.colorbox.close();">OK</a>',
        "content": "<p>Enter quantity to add to cart.</p>",
        "notice": "Notice",
        "templateName":"info_modal"
      });
    }
  }

  // static wizardLoading(patterns, canvas, loading) {
  //   var loadingElements = [];
  //   if (patterns) {
  //     loadingElements.push("#pattern-steps");
  //   }
  //   if (canvas) {
  //     loadingElements.push("#CadXCanvas");
  //   }
  //   $(window.PatternBuilder.config().WIZARD_CONTAINER).find(loadingElements.join(","))[loading ? "addClass" : "removeClass"]("element-loading");
  // }

  

  static doAddToCart(generalErrorMessage) {

    if (addItemToCart) {
      View.wizardLoading(true, false, true);
      addItemToCart.adding();
    }

    if (window.AppInstance.instance().selected.id.length > 0) {
      Pattern.get_custom_pattern_job_data_with_links$()
      .then(function (production_object) {
          PatternBuilderCart.setJobData(production_object);
          console.log(production_object);  
          //fire added to cart 

          $.ajax({
            type: PatternBuilderCart.StahlsAPI().getcart.type,
            url: PatternBuilderCart.StahlsAPI().getcart.endpoint,
            crossDomain: true,
            contentType: "application/json"
          }).then(function (data) {
            var origCart = data;
            var groupedItems = {
              "jobData": PatternBuilderCart.jobData,
              "items": []
            };
            var singleItems = [];

            for (var i = 0, len = PatternBuilderCart.addItems.length; i < len; i++) {
              if ($.inArray(PatternBuilderCart.addItems[i].itemclass, window.PatternBuilder.config().ITEM_CLASSES.GROUPED) >= 0) { // Grouped Item
                groupedItems.items.push(PatternBuilderCart.addItems[i]);
              } else if ($.inArray(PatternBuilderCart.addItems[i].itemclass, window.PatternBuilder.config().ITEM_CLASSES.SINGLE) >= 0) { // Single Item
                singleItems.push(PatternBuilderCart.addItems[i]);
              }
            }

            if (window.AppInstance.instance().GROUPID) {
              groupedItems.groupId = window.AppInstance.instance().GROUPID;
            }

            if (groupedItems.items.length > 0) { // Add the grouped items to the cart
              PatternBuilderCart.postCartGroupCall(JSON.stringify(groupedItems), window.AppInstance.instance().GROUPID, origCart, singleItems);
            } else {
              PatternBuilderCart.singleItemsAddCartCall(origCart, singleItems);
            }
        })
        .fail(function (e) {
          //View.open_colorbox(generalErrorMessage);
          General.errorOut(e);
          if ( addItemToCart !== undefined ) {
            addItemToCart.removed();
          }
          View.wizardLoading(true, false, false);
        });
      })
      // .fail(function (e) {
      //   //View.open_colorbox(generalErrorMessage);
      //   General.errorOut(e);
      //   if ( addItemToCart !== undefined ) {
      //     addItemToCart.removed();
      //   }
      //   View.wizardLoading(true, false, false);
      // });
    } else {
      alert('No document id has been selected');
      if ( addItemToCart !== undefined ) {
      addItemToCart.removed();
    }
    View.wizardLoading(true, false, false);
    }
  }

  static parseYardage(uofm) {
    var justDigits;
    var res;

    uofm = $.trim(uofm);

    if (uofm.match(/ Sh$/)) {
      var y = uofm.replace(/ Sh$/, "");
      var bits = y.split("x");
      var inches = parseFloat(bits[0]);
      res = inches / 36.0;
    } else {
      if (uofm.match(/^Yard$/)) {
        justDigits = "1";
      } else {
        justDigits = uofm.replace(/[A-Za-z ]/g,"");
      }

      res = parseFloat(justDigits);

      // adjust for meter lengths
      if (uofm.match(/.*M.*/)) {
        res = res * 1.09;  // 1.0936133 is actual but Stahls finance is using 1.09
      }
    }

    return res;
  }

  static updateTotalFromQuantities($row) {
    var $total = $row.find("input.total-yardage");
    var total = 0.0, totalString;

    if ($total && $total.length > 0) {
      $row.find("input.uofm").each(function() {
        var yardage = PatternBuilderCart.parseYardage($.trim($(this).data("uofm")));
        var qty = $.trim($(this).val()) || 0;
        total += yardage * parseInt(qty);
      });

      $total.val(total > 0 ? Math.round(total) : "");
    }

    $(".shopAdd").removeClass("added-to-cart");
  }

  static updateQuantitiesFromTotal() {
    var $row = $(this).closest(".wiz-row");
    var $total = $row.find("input.total-yardage");
    var total = parseInt($total.val());
    var roundUp = $total.hasClass("round-up");

    $($row.find("input.uofm").get().reverse()).each(function() {
      var yardage = PatternBuilderCart.parseYardage($.trim($(this).data("uofm")));
      var left = Math[roundUp ? "ceil" : "floor"](total / PatternBuilderCart.parseYardage(yardage))
      $(this).val(left > 0 ? left : "");
      total -= left * yardage;
    });

    $(".shopAdd").removeClass("added-to-cart");

    PatternBuilderCart.getTotalPricing();
  }
}